export default __webpack_public_path__ + "static/media/5brokentelephone.c9161e32.mp3";